module.exports = __webpack_public_path__ + "img/campaign_white.593d85ab.svg";